import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-e9b03c6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "two-step-authentication-page overflow-x-hide" }
const _hoisted_2 = { class: "container no-padding" }
const _hoisted_3 = { class: "row no-margin" }
const _hoisted_4 = { class: "col-md-12 flex-container" }
const _hoisted_5 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "modal-body account-modal" }
const _hoisted_10 = { class: "modal-body-sec1" }
const _hoisted_11 = { class: "auth-modal-text" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = {
  for: "id",
  class: "control-label input-label-form"
}
const _hoisted_14 = { class: "letsgo-btn" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  tabindex: "0",
  class: "forgot-text-button tw-mr-2"
}
const _hoisted_17 = { class: "tw-p-[15px] tw-flex tw-flex-col tw-gap-3" }
const _hoisted_18 = { class: "tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins" }

import HeaderLogo from "@/components/common/headerLogoWithoutLangPicker.vue";
import BrandPattern from "@/components/prospect/brandPattern/brandPattern2.vue";
import $ from "jquery";
import userService from "@/services/user/userService";
import errorhandler from "@/components/common/exceptionHandler.vue";
import Utils from "@/utils/utilities";
import { load } from "recaptcha-v3";
import store from "@/store";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import {
  computed,
  nextTick,
  onBeforeMount,
  onMounted,
  ref,
  watch,
  onBeforeUnmount,
} from "vue";
import router from "@/router";
import { localStorageKey } from "@/utils/constants";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import { showErrorAPI } from "@/services/apiRoutes";
import ButtonShowDuplicateAssessment from "@/components/common/setting/buttonShowDuplicateAssessment.vue";
import CustomDescriptionContent from "../common/customDescriptionContent.vue";
import { submitMFAVerification } from "@/services/user/twoStepAuthenticationService";


export default /*#__PURE__*/_defineComponent({
  __name: 'twoStepAuthentication',
  setup(__props) {

const dyn_height = ref("0");
const disableButton = ref(true);
const windowHeight = ref("");
const showProspectCallbackError = ref(false);
const prospectCallbackErrorMsg = ref("");
const verifyToken = ref("");
const twoStepAuthenticationModal = ref<null>(null);
const totpValid = ref(true);

const languageSelected = computed(
  () => store.state.LanguagePicker.languageSelected,
);
const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);

const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

// get heightSetter() {
//   return { "min-height": `${this.windowHeight}` };
// }

const onVerifyTokenChange = (e) => {
  if (e.target.value && e.target.value.length >= 1) {
    // riggered by a user entering a non-numeric character into the field
    if (isNaN(e.target.value)) {
      totpValid.value = false;
      disableButton.value = true;
    } else {
      if (e.target.value.length >= 6) {
        disableButton.value = false;
      } else {
        disableButton.value = true;
      }
      totpValid.value = true;
    }
  } else {
    totpValid.value = true;
    disableButton.value = true;
  }
};

const code: any = ref();
const onResize = () => {
  dyn_height.value = (window.innerHeight + "px") as string;
  windowHeight.value = "" + window.innerHeight + "px !important ";
  code.value && code.value.focus();
};

onMounted(() => {
  nextTick(function () {
    window.addEventListener("resize", onResize);
    onResize();
  });

  // show twoStepAuthentication Modal
  document.getElementById("twoStepAuthenticationModal")?.classList.add("show");

  const body = $("body");
  if (!body.hasClass("page-opacity")) {
    body.addClass("page-opacity page-bg");
  }

  setLanguages();
  listeningEvent();
});

onBeforeUnmount(() => {
  EventEmitter.off(EmitterEvents.EVENT_KEYBOARD_ENTER);
  EventEmitter.off(EmitterEvents.EVENT_KEYBOARD_ESC);
});

const setLanguages = async () => {
  if (
    localStorage.getItem(localStorageKey.languagesData) == null ||
    localStorage.getItem(localStorageKey.languageList) == null
  ) {
    await Utils.getV3Recaptcha().then(
      async (finalKey: any) => {
        const captchKey = finalKey;
        const recaptcha = await load(`${captchKey}`, {
          autoHideBadge: true,
        });
        recaptcha.execute("submit").then((token) => {
          localStorage.setItem(localStorageKey.recaptcha, token);
          store.dispatch("LanguagePicker/setLanguages", token);
        });
        recaptcha.execute("submit").then((token) => {
          localStorage.setItem(localStorageKey.recaptcha, token);
          store.dispatch("LanguagePicker/setLanguageList", token);
        });
      },
      (error: any) => {
        if (error && error.data && error.data.error && error.data.error.type) {
          if (error.data.error.type === "exc_session_invalid-1") {
            sessionStorage.setItem(
              "prospectCallbackErrorInfo",
              JSON.stringify(error.data.error),
            );
            router.push({ path: "/" });
          } else {
            showErrorInfo(error.data.error);
          }
        } else if (error.data.message === "invalid csrf token") {
          sessionStorage.setItem(
            "prospectCallbackErrorInfo",
            JSON.stringify(error.data),
          );
          router.push({ path: "/" });
        } else {
          showErrorInfo(error.data);
        }
      },
    );
  }
};

const submit = () => {
  submitMFAVerification(
    verifyToken.value,
    disableButton.value,
    totpValid.value,
    {
      getUiText,
      showToastError,
      routerPush: (path) => router.push(path),
      routerGoBack: () => router.go(-1),
      sessionStorageSetItem: (key, value) => sessionStorage.setItem(key, value),
      afterLoginActions: Utils.afterLoginActions,
    },
  );
};

const listeningEvent = () => {
  EventEmitter.on(EmitterEvents.EVENT_KEYBOARD_ENTER, submit);
  EventEmitter.on(EmitterEvents.EVENT_KEYBOARD_ESC, onClickClose);
};

const showErrorInfo = (errorInfo: any) => {
  if (errorInfo && errorInfo !== "") {
    errorInfo =
      typeof errorInfo === "string" ? JSON.parse(errorInfo) : errorInfo;
    if (errorInfo && Object.keys(errorInfo).length > 0 && errorInfo.message) {
      showProspectCallbackError.value = true;
      prospectCallbackErrorMsg.value = errorInfo.message;
    }
  }
};

const showToastError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const resetShowProspectCallbackError = () => {
  showProspectCallbackError.value = false;
  prospectCallbackErrorMsg.value = "";
};

const onClickClose = () => {
  router.go(-1);
};

onBeforeMount(() => {
  removeListeningEvent();
  const body = $("body");
  if (!body.hasClass("page-opacity")) {
    body.addClass("page-opacity page-bg page-shadow");
  }
});

const removeListeningEvent = () => {
  EventEmitter.off(EmitterEvents.EVENT_KEYBOARD_ENTER);
  EventEmitter.off(EmitterEvents.EVENT_KEYBOARD_ESC);
};

const getUiText = (id: string, isArray = false) => {
  return Utils.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "col-md-12",
          style: _normalizeStyle({ 'min-height': dyn_height.value })
        }, [
          _createVNode(HeaderLogo, {
            "page-type": '404',
            light_logo: true
          }),
          _createElementVNode("div", {
            class: "row no-padding main-body h-100",
            style: _normalizeStyle({ height: windowHeight.value })
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(BrandPattern, { page: "TSA" })
            ])
          ], 4)
        ], 4),
        (showProspectCallbackError.value || null)
          ? (_openBlock(), _createBlock(errorhandler, {
              key: 0,
              "prospect-callback-error-msg": prospectCallbackErrorMsg.value,
              onResetShowProspectCallbackError: resetShowProspectCallbackError
            }, null, 8, ["prospect-callback-error-msg"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          id: "twoStepAuthenticationModal",
          ref_key: "twoStepAuthenticationModal",
          ref: twoStepAuthenticationModal,
          class: "modal fade two-step-authentication-modal tw-block",
          role: "dialog",
          "aria-labelledby": "twoStepAuthenticationModalLabel",
          "data-backdrop": "false"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", { class: "modal-header" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  "aria-label": "Close",
                  onClick: onClickClose
                }, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(getUiText("user-mfa-login-heading-1")), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(getUiText("user-mfa-login-heading-sub-1")), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(getUiText("user-mfa-login-enter-code-heading-1")), 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "code",
                    ref_key: "code",
                    ref: code,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((verifyToken).value = $event)),
                    "data-cy": "two-step-authentication-code",
                    type: "text",
                    class: _normalizeClass(`form-control form-control-lg password-input ${
                      !totpValid.value ? 'invalid-input' : ''
                    }`),
                    tabindex: "0",
                    onInput: onVerifyTokenChange
                  }, null, 34), [
                    [_vModelText, verifyToken.value]
                  ]),
                  (!totpValid.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["error-msg", !totpValid.value ? 'mg-top-19' : ''])
                      }, [
                        _createElementVNode("span", null, _toDisplayString(getUiText("user-mfa-setup-error-valid-1")), 1)
                      ], 2))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    id: "signin-button",
                    "data-cy": "two-step-authentication-submit",
                    type: "button",
                    class: "btn btn-primary letsgo-button",
                    disabled: disableButton.value ? true : false,
                    onClick: submit
                  }, _toDisplayString(getUiText(
                        "app-settings-domain-verify-modal-verify-button-1",
                      )), 9, _hoisted_15),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(getUiText("user-mfa-login-lost-mfa-authenticator-code-1")), 1),
                  _createVNode(ButtonShowDuplicateAssessment, {
                    "id-popover": 'popover-two-step-authentication',
                    "custom-class": 'tw-w-[max-content]  md:tw-max-w-[350px] lg:tw-max-w-[470px]',
                    classes: `!tw-leading-none `
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(getUiText(
                            "user-mfa-login-lost-mfa-authenticator-code-tooltip-title-1",
                          )), 1),
                        _createVNode(CustomDescriptionContent, {
                          description: 
                          getUiText(
                            'user-mfa-login-lost-mfa-authenticator-code-tooltip-paragraph-1',
                          )
                        ,
                          class: _normalizeClass(`!tw-p-0 tw-text-[13px] tw-text-[#878787]`)
                        }, null, 8, ["description"]),
                        _createVNode(CustomDescriptionContent, {
                          description: 
                          getUiText(
                            'user-mfa-login-lost-mfa-authenticator-code-tooltip-paragraph-2',
                          )
                        ,
                          class: _normalizeClass(`!tw-p-0 tw-text-[13px] tw-text-[#878787]`)
                        }, null, 8, ["description"])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ], 512)
      ])
    ])
  ]))
}
}

})